import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue'
import {
  MetricValueKind,
  AnnualAggregationMethod,
  useUpdateMetricAssignmentMutation,
} from '~/types/types'
import { GHG_ESTIMATOR_CONCEPT_ID, IMPACT_CARRY_CONCEPT_ID } from '~/constants/concepts'
import { GHG_BY_COMPANY, GHG_BY_IMPACT_SOLUTION } from '~/constants/metrics';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomTarget',
  props: {
    item: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  item: any,
};




const { mutate: updateMetricAssignment } = useUpdateMetricAssignmentMutation()

const valid = ref(true)
const formRef = ref<any>(null)
const isValidation = ref(false)
const options = [
  {
    id: AnnualAggregationMethod.Sum,
    tooltip: null,
    label: 'Sum',
    sublabel: 'sums the ‘actual’ values in the reporting period and compares them with the target value',
  },
  {
    id: AnnualAggregationMethod.Avg,
    tooltip: null,
    label: 'Average',
    sublabel: 'averages across the ‘actual’ values in the reporting period and compares them with the target value',
  },
  {
    id: AnnualAggregationMethod.MostRecent,
    tooltip: null,
    label: 'Most recent value',
    sublabel: 'takes the most recent ‘actual’ value and compares it with the target value',
  },
]
const startDate = ref<string | number>('')
const endDate = ref<string | number>('')
const calculationType = ref<AnnualAggregationMethod>(AnnualAggregationMethod.Sum)
const weight = ref<number | null>(100)
const unsupportedMetricTypes = [
  MetricValueKind.String,
  MetricValueKind.Select,
  MetricValueKind.SingleSelect,
]
const startYearOptions = computed(() => Array.from({ length: 11 }, (_, i) => 2020 + i))
const endYearOptions = computed(() => {
  const parsedStart = Number(startDate.value)
  if (!Number.isFinite(parsedStart)) return startYearOptions.value
  return Array.from({ length: 11 }, (_, i) => parsedStart + i)
})
const isImpactCarryAssignment = computed(() =>
  (props.item?.impacts || []).some(
    (impact: any) => Number(impact?.concept?.id) === IMPACT_CARRY_CONCEPT_ID,
  ),
)
const metricId = computed(() => Number(
  props.item?.metric_id
  ?? props.item?.metricId
  ?? props.item?.metric?.id
  ?? props.item?.metric?.metric_id
))
const isReducedCo2Assignment = computed(() =>
  [GHG_BY_IMPACT_SOLUTION, GHG_BY_COMPANY].includes(metricId.value),
)
const isSupportedMetricType = computed(() => {
  const valueType = props.item?.metric?.valueType
  return !unsupportedMetricTypes.includes(valueType)
})
const invalidDateRange = computed(() => {
  if (startDate.value === '' || endDate.value === '') return false
  const start = Number(startDate.value)
  const end = Number(endDate.value)
  if (!Number.isFinite(start) || !Number.isFinite(end)) return false
  return end < start
})

// Initialize form if editing
watch(
  () => props.item,
  (item) => {
    if (!item) return

    const completionParams = item.completionStatus?.targetParameters
    const legacy = item.targetParameters
    startDate.value =
      item.customTargetStartDate ??
      completionParams?.startDate ??
      legacy?.startDate ??
      ''
    endDate.value =
      item.customTargetEndDate ??
      completionParams?.endDate ??
      legacy?.endDate ??
      ''
    if (item.customTargetCalculationType) {
      calculationType.value = item.customTargetCalculationType
    } else {
      const legacyCalc = completionParams?.calculationType ?? legacy?.calculationType
      calculationType.value =
        legacyCalc === 'average'
          ? AnnualAggregationMethod.Avg
          : legacyCalc === 'most_recent_value'
            ? AnnualAggregationMethod.MostRecent
            : AnnualAggregationMethod.Sum
    }
    weight.value = item.customTargetWeight ?? completionParams?.weight ?? legacy?.weight ?? 100
  },
  { immediate: true }
)

function validateForm() {
  return formRef.value?.validate ? formRef.value.validate() : true
}

function submit() {
  if (!isSupportedMetricType.value || invalidDateRange.value) return
  if (validateForm() && calculationType.value) {
    isValidation.value = false
    const normalizeOptionalInt = (v: string | number | null | undefined): number | null => {
      if (v === '' || v === null || v === undefined) return null
      const n = Number(v)
      return Number.isFinite(n) ? n : null
    }

    updateMetricAssignment({
      input: {
        id: props.item.id,
        customTargetStartDate: normalizeOptionalInt(startDate.value),
        customTargetEndDate: normalizeOptionalInt(endDate.value),
        customTargetCalculationType: calculationType.value,
        customTargetWeight: Number(weight.value),
      },
    })
    emit('close')
  } else {
    isValidation.value = true
  }
}

return { __sfc: true,props, emit, updateMetricAssignment, valid, formRef, isValidation, options, startDate, endDate, calculationType, weight, unsupportedMetricTypes, startYearOptions, endYearOptions, isImpactCarryAssignment, metricId, isReducedCo2Assignment, isSupportedMetricType, invalidDateRange, validateForm, submit }
}

})